<template>
  <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="form-group">
                <fieldset class="col-md-6 mb-3">
                    <model-select :options="cfcs" v-model="selectedCFC" placeholder="Selecione uma autoescola"></model-select>
                </fieldset>
                <div class="col-md-3">
                    <input type="date" id='dataInicial'>
                </div>
                <div class="col-md-3">
                    <input type="date" id='dataFinal'>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getAlunosCadastrados()" class="btn btn-primary btn-micro">Gerar Relatório</button>
                </div>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
</div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApiV2 from '@/router/urlApiV2'
import { ModelSelect } from 'vue-search-select'

export default {
    name: 'alunosCadastrados',
    components: {
        ...spinners,
        ModelSelect
    },
    data() {
        return {
            cfcs: [],
            selectedCfcs: [],
            selectedCFC: false,
            download:{
                load: false
            },
        }
    },
    mounted() {
        this.getCfcs();
    },
    methods: {
        getCfcs() {
            this.$http.get(process.env.VUE_APP_URL_API_V2 + '/autoescola').then(response => {
                response.data.dados.map(autoescolas => {
                    if (autoescolas.nome_fantasia !== 'TESTE') {
                        this.cfcs.push({
                            value: autoescolas.tenant_schema,
                            text: autoescolas.nome_fantasia,
                        })
                    }
                })
            })
        },
        getAlunosCadastrados(){
            this.download.load = true;
            let dataI = document.getElementById('dataInicial').value;
            let dataF = document.getElementById('dataFinal').value;

            if(!this.selectedCFC)
            {
                this.$toasted.show('Por favor, selecione uma autoescola!', {
                    position: 'top-right',
                })
                this.download.load = false;
                return;
            }else if(dataI === '' || dataF === '') {
                this.$toasted.show('Por favor, informe o período!', {
                    position: 'top-right',
                })
                this.download.load = false;
            } else {
                this.$http.get(urlApiV2 + '/alunos/relatorio/cadastrados/' + dataI + '/' + dataF + '?schema='+this.selectedCFC )
                .then(this.downloadCSV)
                .catch(error => {
                    this.download.load = false;
                })
            }
        },
        downloadCSV(response){
            if(response.data.dados){
                var dlnk = document.getElementById('downloadCSV');
                dlnk.download="novoCFC.csv";
                dlnk.href = 'data:text/csv;charset=utf-8,' + response.data.dados;
                dlnk.click();
                this.download.load = false;
            }else{
                this.$toasted.show('Consulta não possui resultado', {
                    position: 'top-right',
                })
                this.download.load = false;
            }
        },
    },
}
</script>
